
import { Button } from '@/components/ui/button';
import { RefreshCw, LogOut, BuildingIcon } from 'lucide-react';

interface PEODashboardHeaderProps {
  loading: boolean;
  onRefresh: () => void;
  onLogout: () => void;
}

export const PEODashboardHeader = ({ loading, onRefresh, onLogout }: PEODashboardHeaderProps) => (
  <div className="flex justify-between items-center bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
    <div className="flex items-center gap-3">
      <div className="bg-primary/10 p-2 rounded-lg">
        <BuildingIcon className="h-6 w-6 text-primary" />
      </div>
      <h1 className="text-3xl font-bold bg-gradient-to-r from-primary to-primary-light bg-clip-text text-transparent">
        PEO Provider Dashboard
      </h1>
    </div>
    <div className="flex gap-3">
      <Button
        onClick={onRefresh}
        variant="outline"
        disabled={loading}
        className="flex items-center gap-2 border-gray-200 bg-white"
      >
        <RefreshCw className={`h-4 w-4 ${loading ? 'animate-spin' : ''} text-primary`} />
        Refresh
      </Button>
      <Button
        onClick={onLogout}
        variant="outline"
        className="flex items-center gap-2 bg-primary/10 border-primary/30 hover:bg-primary/20 text-primary"
      >
        <LogOut className="h-4 w-4" />
        Logout
      </Button>
    </div>
  </div>
);
